import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

const DEFAULT_TOP_BLUR_COLOR = '#6153D0'

type BasicLayoutStoreType = {
  isTopBlurVisible: boolean
  topBlurColor: string
}

const initialState: BasicLayoutStoreType = {
  isTopBlurVisible: true,
  topBlurColor: DEFAULT_TOP_BLUR_COLOR
}

const useStore = createWithEqualityFn<BasicLayoutStoreType>(() => initialState, shallow)

export const basicLayoutStore = {
  setPurpleTopBlurVisibility: (isVisible: boolean): void => {
    useStore.setState({ isTopBlurVisible: isVisible })
  },

  clearStore: (): void => {
    useStore.setState(initialState)
  },
  useStore
}
